export default function(string) {
  if (string) {
    return string
      .replace(/(?:\*)([^*]*)(?:\*)/gm, "<strong>$1</strong>")
      .replace(/(?:_)([^_]*)(?:_)/gm, "<i>$1</i>")
      .replace(/(?:~)([^~]*)(?:~)/gm, "<strike>$1</strike>")
      .replace(/(?:```)([^```]*)(?:```)/gm, "<tt>$1</tt>")
  }
}
